module.exports = __webpack_public_path__ + "static/img/组 2837.ae6e2d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/组 2837.png
// module id = FVN5
// module chunks = 0